import React, { ReactElement, useState } from 'react'
import styled from 'styled-components'

import { DayPicker } from 'components/v2/DayPicker'
import Dropdown from 'components/v2/Dropdown'
import { CalendarIcon } from 'components/Icons/CalendarIcon'
import { Input } from 'components/Input'
import { CircleCloseIcon } from '@10xLabs/react-web/components/Icons/CircleClose'
import { dateToString } from 'utils/date'
import { device } from 'utils/style'
import { IInputDateProps } from './types'

const StyledDatePicker = styled.div<TSFixMe>`
  border-top: 1px solid #f2f2f2;
  padding: 20px 0 0;
  display: flex;
  justify-content: center;

  > div {
    font-size: 1.1rem;
  }

  @media ${device.tablet} {
    display: block;
    padding: 10px;
  }
`

const StyledCalendarIcon = styled(CalendarIcon)`
  fill: #916ee8;
`

const CloseIconWrapper = styled.div`
  display: flex;
  cursor: pointer;

  svg {
    fill: #9999bd;
    width: 18px;
    height: 18px;
  }
`

const DropdownContainer = styled(Dropdown.Content)`
  z-index: 10;
`

const InputDate = ({
  label,
  onChange,
  value,
  placeholder,
  touched,
  errors,
  id,
  optional,
  disabledDays,
  readOnly,
  timeZone,
  disabled,
  center = true,
  left,
  right,
  defaultMonth,
  ...props
}: IInputDateProps): ReactElement => {
  const [isOpen, setOpen] = useState(false)

  const isEditable = !readOnly && !disabled

  const handleDateChange = (newDate?: Date): void => {
    setOpen(false)
    if (newDate) {
      onChange(newDate)
    }
  }

  const handleReset = (event: React.SyntheticEvent): void => {
    event.stopPropagation()
    event.preventDefault()

    onChange()
  }

  const dateStr = dateToString(value, timeZone)
  const showReset = Boolean(dateStr && optional)

  return (
    <>
      <Dropdown.Wrapper onClickAway={(): void => setOpen(false)} form>
        <Input
          id={id}
          value={dateStr}
          onChange={(): void => undefined}
          onClick={(): void => setOpen(!isOpen)}
          placeholder={placeholder}
          errors={errors}
          touched={touched}
          label={label}
          iconLeft={<StyledCalendarIcon />}
          iconRight={
            showReset &&
            isEditable && (
              <CloseIconWrapper onClick={handleReset}>
                <CircleCloseIcon />
              </CloseIconWrapper>
            )
          }
          disabled={disabled || readOnly}
          isOpen={isOpen}
          isDropdown={isEditable && !showReset}
          optional={optional}
          {...props}
        />
        {isEditable && (
          <DropdownContainer
            open={isOpen}
            center={center}
            right={right}
            left={left}
            noPadding
            fitContent
            form
            noOverflow
          >
            <StyledDatePicker>
              <DayPicker
                value={value}
                onChange={handleDateChange}
                disabledDays={disabledDays}
                defaultMonth={defaultMonth}
              />
            </StyledDatePicker>
          </DropdownContainer>
        )}
      </Dropdown.Wrapper>
    </>
  )
}

export { InputDate }
